import { jsonFetch } from "utils";

export const getCompany = (id) =>
  jsonFetch(`${apiUrl}public/v1/companies/${id}`, {
    method: "GET",
  });

export default getCompany;
